<template>
  <div>
        <div class="row justify-content-center" >
            <div class="col-md-5">
                <br>
                <div class="col-md-11">
                    <img src="fotos/notificacion.png" style="width: 150px; margin-left: -220px;" >
                </div>
                <div class="row justify-content-center" style="margin-top: -150px;">
                   <div class="col-md-10 mt-5"  v-for="com in arrayComent" :key="com.id" v-show="arrayComent.length > 0">
                       
                       
                       <b-card style="border-radius: 20px;">
                            <b-card-text>
                            <div class="row justify-content-center"  >
                                <div class="col-md-3">
                                    <img src="icon/usern.png" width="80"> 
                                </div>
                                <div class="col-md-9">
                                    <b>GERENTE {{nombre_gerente}}</b>
                                    <p>{{com.contenido}}</p>
                                    <em>{{com.created_at | fechaA}}</em>
                                </div>    
                                <div class="col-md-7"></div>
                                <div class="col-md-5 mt-3">
                                    <b-button variant="outline-dark"  size="sm" @click="respondeMsj(com.id)">
                                        Responder
                                    </b-button>
                                    <b-button variant="outline-dark" class="ml-2" size="sm" @click="eliminaMensaje(com.id)">
                                        Eliminar
                                    </b-button>
                                </div>                        
                            </div>
                            </b-card-text>
                        </b-card>
                        

                    </div>
                    <div class="col-md-12" v-if="arrayComent.length == 0" style="background: #FCFCFC; box-shadow: inset 0 0 10px 0 #CDCDCD;">
                        <center>
                          <br>
                          <h4 style="color:#098FD6; marg">Nada que mostrar.</h4> 
                          <br>
                        </center>
                    </div>
                </div>
                <br>
                <hr style="border-top: 5px solid #60CD31 !important;  opacity :0.8;">    
                <br><br><br>
                
            </div>
         </div>

         
         <b-modal id="enviarMensaje" title="Enviar Mensaje" size="lg" hide-footer header-close-content="Cerrar">
            <div class="row  justify-content-center">
                <div class="col-md-10 mt-3">
                    <b-form-textarea
                        id="textarea"
                        v-model="mensaje"
                        placeholder="Responder notificación"
                        rows="6"
                        max-rows="6"
                    ></b-form-textarea>
                    <hr style="border-top: 5px solid #60CD31 !important;  opacity :0.8;">  
                    <center>
                        <b-button  variant="primary" pill  style="margin-top: 25px; width: 20%; background: #039cf3; border-color: #CDCDCD;" size="sm" @click="enviaMensaje()">
                            Enviar  <b-spinner small v-if="loader"></b-spinner>
                        </b-button>
                    </center>
                </div>
            </div>                       
         </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import Swal from 'sweetalert2'
export default {
    name:"Notificacion",
    data() {
      return {
        seccion:0,
        arrayComent:[],
        mensaje:"",
        loader:false,
        gerente:"",
        publica:0,
        nombre_gerente:""
      }
    },
    filters: {
        fechaA:function(value) {
            if (value) {
                moment.locale('es')
                return moment(String(value)).format('YYYY-MM-DD h:mm:ss a')
            }
        }
    },
    computed: {
        user() {
           return this.$store.getters.getInfoUser;
        },
    },
    methods:{
      getNoti(){
           var url= 'cantado/notificaEjecutivo?idpdv='+ this.user.id_pdv + '&axc=' +  this.user.mrt;
            this.$api.get(url).then(
                ({data}) => {
                    console.log(data);
                    this.arrayComent = data.data.comentario;    
                    this.gerente = data.data.gerente;
                    this.nombre_gerente = data.data.nombre;
                }
            );  
      },
      eliminaMensaje(id){
         Swal.fire({
                title: '¿Estás seguro de eliminar esta notificación?',
                showCancelButton: true,
                confirmButtonColor: '#7B2AB4',
                cancelButtonColor: '#187abe',
                confirmButtonText: 'Rechazar',
                cancelButtonText:'Cancelar',
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed)
                {
                    var url= 'cantado/eliminar?id='+ id;
                    this.$api.get(url).then(
                            ({data}) => {
                                console.log(data);
                                this.getNoti();
                                 this.$bus.$emit("actualizaNot")
                                Swal.fire(
                                    "List@",
                                    "Notificacion eliminada exitosamente.",
                                    'success'
                                    )
                            }
                        );             
                }
            })
      },
      enviaMensaje(){
        if (!this.mensaje) {
            Swal.fire({
                icon: 'error',
                title: 'Ingrese Mensaje.',
                text: 'Campo requerido.'
            })
        } else {
            this.loader = true;
          var url= 'cantado/mensaje?idpdv='+ this.user.id_pdv + '&axc=' + this.user.mrt + '&gerente=' + this.gerente + '&perfil=' + this.user.perfiles[0].perfil.id 
              + '&mensaje=' + this.mensaje + this.user.perfiles[0].perfil.id + '&publica=' + this.publica;
            this.$api.get(url).then(
                ({data}) => {
                    console.log(data);
                    this.mensaje = "";
                    this.arrayComent = data.data.comentario; 
                    this.$bvModal.hide('enviarMensaje')   
                    this.getNoti();
                     this.$bus.$emit("actualizaNot")
                    this.loader = false;
                       Swal.fire(
                        "List@",
                        "Correo enviado exitosamente.",
                        'success'
                        )  
                }
            );
        }
      },
      respondeMsj(id){
        this.publica = id;
        this.$bvModal.show('enviarMensaje')
      }
    },
    mounted(){
        this.getNoti();
    }
}
</script>

<style>

</style>